import {Component, Input, OnInit} from '@angular/core';
import {FieldType} from "@ngx-formly/core";

@Component({
  selector: 'formly-multi-select-field',
  template: `
    <ds-hybrid-field
      name="{{label}}"
      [id]="label"
      multiple
      placeholder="{{label}}"
      required="{{ required }}"
      label="{{ label }}"
      noresults="No results found"
      [formlyAttributes]="field"
      [invalid]="invalid"
      (dsHybridFieldSelect)="onSelect($event)"
    >

      <ds-menu-item *ngFor="let item of to.options" [value]="item.label">
        {{item.value}}
      </ds-menu-item>

    </ds-hybrid-field>

  `,
  styles: [],
})
export class FormlyMultiSelectFieldComponent extends FieldType implements OnInit {
  @Input() helpertext: string;
  @Input() label: string;
  @Input() name: string;
  @Input() placeholder: string;
  @Input() required?: boolean;
  @Input() hide: boolean;
  @Input() invalidtext: string;

  public get invalid(): boolean {
    return this.formControl?.touched ? this.formControl.invalid : false;
  }

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.label = this.to.label;
    this.placeholder = this.to.placeholder;
    this.helpertext = this.to.helpertext;
    this.required = this.to.required;
    this.name = this.key.toString();
    this.invalidtext = this.to.invalidtext;

    // Hide expression is defined client side
    // In this case, the component must be custom for german federal state field and not a generic multi select field
    // this.field.hideExpression = (model, formState, field) => {
    //   return model['german-resident'] === 'No' || model['german-resident'] === '' || model['german-resident'] === null || model['german-resident'] === undefined;
    // };

    // Hide expression come from server
    // In this case the component is a generic multi select field
    if (this.to.hideExpression && this.to.hideExpression !== '') {
      this.field.hideExpression = this.evaluateHideExpression(this.model, this.formState, this.field);
    }
  }

  evaluateHideExpression(model, formState, field) {
    // Transform the string expression coming from the db to a function
    const fn = new Function('model', 'formState', 'field', `return ${this.to.hideExpression}`);
    return fn(model, formState, field);
  }

  onSelect({detail}) {
    // It needs to set the field values in this way in order to not get an error
    // when multiple selection is enabled
    this.field.formControl.patchValue(detail.selected.map(item => item.value));
  }
}
